import { useCallback, useState } from "react"
import { ImageGalleryItem } from "@/shared/components/image-gallery"

interface ImageGalleryViewerState {
  items: ImageGalleryItem[]
  initialIndex: number
}

const clampIndex = (index: number, length: number) => Math.max(0, Math.min(index, Math.max(0, length - 1)))

const useImageGalleryViewer = () => {
  const [viewer, setViewer] = useState<ImageGalleryViewerState | null>(null)

  const openWithItems = useCallback((items: ImageGalleryItem[], initialIndex = 0) => {
    const validItems = items.filter(item => item?.url)
    if (validItems.length === 0) return
    setViewer({
      items: validItems,
      initialIndex: clampIndex(initialIndex, validItems.length)
    })
  }, [])

  const openWithImages = useCallback(
    (images: string[], initialIndex = 0, imageAlts?: string[]) => {
      const items = images.reduce<ImageGalleryItem[]>((acc, url, index) => {
        if (!url) return acc
        acc.push({
          url,
          alt: imageAlts?.[index]
        })
        return acc
      }, [])
      openWithItems(items, initialIndex)
    },
    [openWithItems]
  )

  const closeViewer = useCallback(() => {
    setViewer(null)
  }, [])

  return {
    viewer,
    openWithItems,
    openWithImages,
    closeViewer
  }
}

export { useImageGalleryViewer }
